import Toastify from 'toastify-js'
import validate from 'jquery-validation'
import * as select2 from 'select2'

export default () => {
	let toastJs = false
	$('.frm-test-visa input').change(function (){
		if( toastJs ){
			toastJs.hideToast()
		}
	})
	
	$('.frm-test-visa .btn:not([type="submit"])').click(function (e){
		e.preventDefault()
		
		const step = parseInt($(this).data('step'))
		const eleStep = $('#frmTestVisaStep'+step)
		if (eleStep.length) {
			let allowChange = true
			if ($(this).data('role') === 'next') {
				const currStep = step - 1
				const eleCurrStep = $('#frmTestVisaStep'+ currStep)
				const inputType = $('input', eleCurrStep).attr('type')
				if ((inputType === 'radio' || inputType === 'checkbox') && !$('input:checked', eleCurrStep).length) {
					allowChange = false
					toastJs = Toastify({
						text: 'Vui lòng chọn đáp án phù hợp.',
						className: 'error',
						close: true,
						gravity: 'top', // `top` or `bottom`
						// position: 'right ', // `left`, `center` or `right`
						stopOnFocus: true,
						style: {
							// background: "linear-gradient(to right, #00b09b, #96c93d)", //success
							background: 'linear-gradient(to right, rgb(255, 95, 109), rgb(255, 195, 113))' //error
						}
					}).showToast()
				}
				// else {
				// 	const inputVal = $('input', eleCurrStep).val()
				// 	if (!inputVal || !inputVal.length) {
				// 		allowChange = false
				// 		toastJs = Toastify({
				// 			text: 'Vui lòng nhập đáp án.',
				// 			className: 'error',
				// 			close: true,
				// 			gravity: 'bottom', // `top` or `bottom`
				// 			// position: 'right ', // `left`, `center` or `right`
				// 			stopOnFocus: true,
				// 			style: {
				// 				// background: "linear-gradient(to right, #00b09b, #96c93d)", //success
				// 				background: 'linear-gradient(to right, rgb(255, 95, 109), rgb(255, 195, 113))' //error
				// 			}
				// 		}).showToast()
				// 	}
				// }
			}
			
			if (allowChange) {
				$('.frm-test-visa').addClass('d-none')
				const _form = $('#frmTestVisaStep' + $(this).data('step'))
				_form.removeClass('d-none')
				if( $('.select2', _form).length ) {
					$('.select2', _form).select2({
						placeholder: 'Vui lòng chọn Quốc gia',
						allowClear: true
					})
				}
			}
		}
	})
	$('.select2').select2({
		placeholder: 'Vui lòng chọn Quốc gia',
		allowClear: true
	})
	$('#frmTestVisa').validate({
		rules: {
			fullname: 'required',
			email: {
				required: true,
				email: true
			},
			phone: 'required',
		},
		messages: {
			fullname: 'Vui lòng nhập họ tên.',
			email: {
				required: 'Vui lòng nhập email.',
				email: 'Email không hợp lệ.'
			},
			phone: 'Vui lòng nhập số điện thoại.',
		},
		errorClass : 'is-invalid',
		errorPlacement: function(error, element) {
			error.insertAfter(element)
				.addClass('invalid-feedback')
		},
		// submitHandler: function(form) {
		// 	$.ajax({
		// 		url: visa.ajaxUrl,
		// 		type: 'post',
		// 		dataType: 'json',
		// 		data: $(form).serialize(),
		// 		beforeSend: function () {
		// 			$('input, button, select', $(form)).prop('disabled', true)
		// 		},
		// 		success: function(response) {
		// 			console.log(response)
		// 		}
		// 	})
		// 	return false
		// }
	})
	
	// const calculatePercent = (percent) => {
	//
	// 	//work out the circumference from the width
	// 	const diameter = 124
	// 	const circumference = Math.ceil(diameter * Math.PI)
	// 	//now we have the circumference, we know how long the ouline should be
	// 	const stroke = Math.ceil(circumference * percent)
	// 	//also workout how long the line doesn't exist for
	// 	const diff = circumference - stroke
	//
	// 	//now add the strok dash array for the first two values
	// 	//TODO : could this all be done with css?
	// 	// el.querySelector('.percent-circle-inner').style.strokeDasharray = stroke +'px '+ diff +'px';
	// 	// console.log(percent)
	// 	// console.log(stroke)
	// 	// console.log(diff)
	// 	// $('#circle-color').css({
	// 	// 	strokeDasharray: stroke +'px '+ diff +'px'
	// 	// })
	//
	// 	// document.querySelector('.circle-color').style.strokeDasharray = stroke +'px '+ diff +'px'
	//
	// }
	// calculatePercent(75)
}